import { Box, Collapse, IconButton, Typography } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { AxiosError, AxiosResponse } from "axios";
import { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { savePdfUrls } from "../../../Redux/Actions/Index";
import PermissionComponent, {
  getPermissionDisplayName,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import { AddIcon, RemoveICon } from "../../../Shared/Icons";
import ArchiveModal from "./ArchiveModal";
import Expand from "./Expand";
import ResendModal from "./ResendModal";
import useLang from "Shared/hooks/useLanguage";
import Status from "Shared/Common/Status";
import { DownloadFileWithData } from "Services/PGXLis/ResultUpload";

function Row({
  item,
  tabPanel,
  selectedBox,
  setSelectedBox,
  loadGridData,
}: any) {
  const { t } = useLang();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showResend, setShowResend] = useState(false);

  const ShowBlob = async (tempId: number, fileId: number, fileName: string) => {
    try {
      const res: AxiosResponse = await DownloadFileWithData(tempId, fileId);
      const downloadLink = document.createElement("a");
      downloadLink.href = `data:${res?.data?.data?.contentType};base64,${res?.data?.data?.fileContents}`;
      downloadLink.download = `${fileName}.xlsx`;
      downloadLink.click();
    } catch (err) {
      const error = err as AxiosError;
      console.error(error);
    }
  };

  const handleChangeRequisitionIds = (checked: boolean, id: number) => {
    if (checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: [...selectedBox.id, id],
        };
      });
    }
    if (!checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          id: selectedBox.id.filter((item: any) => item !== id),
        };
      });
    }
  };

  return (
    <>
      <ArchiveModal
        show={show}
        setShow={setShow}
        selectedRecord={[item.id]}
        loadGridData={loadGridData}
        setSelectedBox={setSelectedBox}
      />
      <ResendModal
        id={item.id}
        show={showResend}
        setShow={setShowResend}
        loadGridData={loadGridData}
        templateId={item.templateId}
      />
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }} key={item.id}>
        {tabPanel === "1" ? (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
            >
              {open ? (
                <button
                  id={`PGXResultFileClose_${item.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
                >
                  <RemoveICon />
                </button>
              ) : (
                <button
                  id={`PGXResultFileOpen_${item.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-primary rounded h-20px w-20px min-h-20px"
                >
                  <AddIcon />
                </button>
              )}
            </IconButton>
          </TableCell>
        ) : null}
        {tabPanel === "1" ? (
          <TableCell>
            <label className="form-check form-check-sm form-check-solid">
              <input
                id={`IdResultFileCheckBox_${item.id}`}
                className="form-check-input"
                type="checkbox"
                checked={selectedBox?.id?.includes(item?.id)}
                onChange={(e) =>
                  handleChangeRequisitionIds(e.target.checked, item.id)
                }
              />
            </label>
          </TableCell>
        ) : null}
        {tabPanel === "1" ? (
          <TableCell>
            <div className="d-flex justify-content-center rotatebtnn">
              <DropdownButton
                className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                key="end"
                id={`AdminUserList3Dots_${item.id}`}
                drop="end"
                title={<i className="bi bi-three-dots-vertical p-0"></i>}
              >
                <PermissionComponent
                  moduleName="PGX LIS"
                  pageName="Result File"
                  permissionIdentifier="Resend"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <Dropdown.Item
                      id={`AdminUserListEdit`}
                      eventKey="1"
                      className="menu-item p-0"
                      onClick={() => setShowResend(true)}
                    >
                      <span className="menu-link text-dark">
                        <i className="fa-solid fa-arrow-rotate-right text-primary mr-2  w-20px"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Resend"
                        )}
                      </span>
                    </Dropdown.Item>
                  )}
                </PermissionComponent>
                <PermissionComponent
                  moduleName="PGX LIS"
                  pageName="Result File"
                  permissionIdentifier="Archive"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <Dropdown.Item
                      id={`AdminUserListArchived`}
                      eventKey="2"
                      className="menu-item p-0"
                      onClick={() => setShow(true)}
                    >
                      <span className="menu-link text-dark">
                        <i className="fa fa-trash text-danger mr-2  w-20px"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Archive"
                        )}
                      </span>
                    </Dropdown.Item>
                  )}
                </PermissionComponent>
              </DropdownButton>
            </div>
          </TableCell>
        ) : null}

        <TableCell id={`IdResultFileName_${item.id}`}>
          {item?.fileName}
        </TableCell>
        <TableCell className="text-center">
          <PermissionComponent
            moduleName="PGX LIS"
            pageName="Result File"
            permissionIdentifier="DownloadFile"
          >
            <button
              id={`IdResultFileDownload_${item.id}`}
              className="btn btn-icon btn-sm fw-bold btn-warning"
              disabled={item.azureLink === null ? true : false}
              onClick={() => ShowBlob(item.templateId, item.id, item.fileName)}
            >
              <i className="fa fa-download"></i>
            </button>
          </PermissionComponent>
        </TableCell>
        <TableCell className="text-center">
          <PermissionComponent
            moduleName="PGX LIS"
            pageName="Result File"
            permissionIdentifier="View"
          >
            <Link to={`/docs-viewer`} target="_blank">
              <button
                id={`IdResultFileView_${item.id}`}
                className="btn btn-icon btn-sm fw-bold btn-success btn-icon-light"
                onClick={() => {
                  dispatch(savePdfUrls(item.azureLink));
                }}
              >
                <i className="fa fa-eye cursor-pointer"></i>
              </button>
            </Link>
          </PermissionComponent>
        </TableCell>
        <TableCell
          id={`IdResultFileStatus_${item.id}`}
          sx={{ width: "max-content", textAlign: "center" }}
        >
          <Status
            cusText={item?.status}
            cusClassName={
              item?.status === t("Success")
                ? "badge-status-success"
                : item?.status === t("Invalid Format")
                  ? "badge-status-invalid-format"
                  : item?.status === t("Pending")
                    ? "badge-status-pending"
                    : item?.status === t("Fail")
                      ? "badge-status-fail"
                      : "badge-status-default"
            }
          />
        </TableCell>
        <TableCell id={`IdResultFileDataType_${item.id}`}>
          {item?.fileDataType}
        </TableCell>
        <TableCell id={`IdResultFileUploadedDate_${item.id}`}>
          {item?.uploadedDate}
        </TableCell>
        <TableCell id={`IdResultFileUploadedTime_${item.id}`}>
          {item?.uploadedTime}
        </TableCell>

        <TableCell id={`IdResultFileUploadedBy_${item.id}`}>
          {item?.uploadedBy}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={9} className="padding-0">
          <Collapse in={open} unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography gutterBottom component="div">
                <div className="table-expend-sticky">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xxl-12 px-lg-14 px-md-10 px-4">
                      <Expand key={item.id} fileId={item.id} />
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
